import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ApiService } from '../../api/services/api.service';
import { Page } from '@nousmedis/cc-types';

export interface SnapshotSummary {
  _id: string;
  operationType: 'cell_update' | 'page_save' | 'format_change' | 'restore';
  createdBy?: { name: string; surname: string };
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class FascicleHistoryService {
  private get urlBase(): string { return this.api.getBaseUrl(); }

  historyList$ = new BehaviorSubject<SnapshotSummary[]>([]);
  restoring$ = new BehaviorSubject<boolean>(false);

  constructor(private api: ApiService) {}

  private historyUrl(idCatalog: string, idFascicle: string): string {
    return `${this.urlBase}/api/v1/catalog/${idCatalog}/fascicles/${idFascicle}/history`;
  }

  loadHistory(idCatalog: string, idFascicle: string): void {
    this.api
      .get(this.historyUrl(idCatalog, idFascicle))
      .pipe(catchError(() => of([])))
      .subscribe((list: SnapshotSummary[]) => this.historyList$.next(list));
  }

  createSnapshot(
    idCatalog: string,
    idFascicle: string,
    pages: Page[],
    operationType: SnapshotSummary['operationType']
  ): Observable<any> {
    return this.api
      .post(this.historyUrl(idCatalog, idFascicle), { pages, operationType })
      .pipe(
        tap(() => this.loadHistory(idCatalog, idFascicle)),
        catchError(() => of(null))
      );
  }

  restore(idCatalog: string, idFascicle: string, snapshotId: string): Observable<{ pages: Page[] }> {
    this.restoring$.next(true);
    return this.api
      .post(`${this.historyUrl(idCatalog, idFascicle)}/restore/${snapshotId}`, {})
      .pipe(
        tap(() => {
          this.restoring$.next(false);
          this.loadHistory(idCatalog, idFascicle);
        }),
        catchError((err) => {
          this.restoring$.next(false);
          throw err;
        })
      ) as Observable<{ pages: Page[] }>;
  }
}
